import { inject, singleton } from "tsyringe";
import axios from "axios";

// shared
import { REFRESH_URL } from "@/shared/libs/http/config";
import {
    setAccessToken,
    setRefreshToken,
    removeRefreshToken,
} from "@/shared/libs/state-management/token-manage";
import type { RefreshTokenResponse } from "@/shared/libs/http/axios/interface";

@singleton()
export class AccessTokenRefresher {
    promise: Promise<string> | undefined;
    baseURL: string;

    constructor() {
        this.promise = undefined;
        this.baseURL = import.meta.env.VITE_API_URL;
    }

    public refresh = async (userRefreshToken: string): Promise<string> => {
        /** refresh 요청 중이라면 */
        if (this.promise) return this.promise;

        /** accessToken 을 다시 반환
         * 테스트 : import.meta.env.VITE_DOCKER_API_URL
         */
        this.promise = (async () => {
            try {
                const responseToken = await axios.post<RefreshTokenResponse>(
                    `${this.baseURL}${REFRESH_URL}`,
                    {
                        refreshToken: userRefreshToken,
                    },
                );
                /** 생성된지 7일이 지났다면 */
                if (responseToken.data.refreshToken !== undefined) {
                    setRefreshToken(responseToken.data.refreshToken);
                }
                setAccessToken(responseToken.data.accessToken);

                this.promise = undefined;

                return responseToken.data.accessToken;
            } catch (error) {
                this.promise = undefined;
                // refreshToken 을 삭제해야 재 로그인 모달창 open
                removeRefreshToken();
                return "";
            }
        })();

        return this.promise;
    };
}
